<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarSectionHeaderProps {
  headerType?: 'form-header' | 'menu-header' | 'list-header';
  type?: 'default' | 'error' | 'warning' | 'danger';
  iconTemplate?: IconConstant | '';
  label?: string;
}

const props = withDefaults(defineProps<GrammarSectionHeaderProps>(), {
  headerType: 'form-header',
  type: 'default',
  iconTemplate: '',
  label: '',
});
</script>

<template>
  <tpg-section-header v-bind="props" />
</template>
